export const STORY_LENGTH_LIMIT = 1100;
